<template>
  <v-row>
    <v-col>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-on="on" v-bind="attrs" class="mr-2" v-if="isComplete"
            >info</v-icon
          >
          <v-progress-circular
            v-show="!isComplete"
            :size="25"
            :width="2"
            :indeterminate="true"
            class="mr-2"
            v-bind="attrs"
            v-on="on"
          ></v-progress-circular>
        </template>
        <v-container v-if="statuses.length > 0">
          <p v-for="s of statuses" :key="s.id">
            <strong>{{ s.provider.replace("GTWEB_", "") }}:</strong>
            {{ s.status }}, {{ s.total }} records found.
          </p>
        </v-container>
        <v-container v-else>
          <p>Loading...</p>
        </v-container>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../../helpers";
import EventBus from "../../../../../store/event-bus";
const CHECK_STATUS = gql`
  query rsStatuses($rsId: ID!) {
    rsStatuses(rsId: $rsId) {
      edges {
        node {
          id
          provider
          createdAt
          updatedAt
          status
          message
          total
        }
      }
    }
  }
`;
export default {
  name: "rate-search-status",

  props: {
    searchId: {
      type: String,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      checkStatus: true,
      reloader: null,
    };
  },

  computed: {
    statuses() {
      return this.rsStatuses && this.rsStatuses.edges
        ? this.rsStatuses.edges.map(removeGQLTypename)
        : [];
    },
    isComplete() {
      if (this.statuses.length > 0) {
        const completed = this.statuses.filter(
          (item) => item.status == "COMPLETE" || item.status == "ERROR"
        );
        return this.rsStatuses.edges.length == completed.length;
      } else {
        return false;
      }
    },
  },

  methods: {
    reload() {
      if (this.$apollo.queries.rsStatuses != null) {
        this.$apollo.queries.rsStatuses.refetch();
      }
    },
  },

  apollo: {
    rsStatuses: {
      query: CHECK_STATUS,
      variables() {
        return {
          rsId: this.searchId,
        };
      },
      result({ data }) {
        this.checkStatus = false;

        const statuses = data.rsStatuses.edges.map(removeGQLTypename);
        if (statuses.length > 0) {
          const completed = statuses.filter(
            (item) => item.status == "COMPLETE" || item.status == "ERROR"
          );
          if (statuses.length == completed.length) {
            clearInterval(this.reloader);
          }
        }
        const errors = statuses.filter((item) => item.status == "ERROR");
        if (errors.length > 0) {
          //show error message
          this.$store.dispatch("showAppSnackbar", {
            msg: errors.map((item) => item.message).join(", "),
            color: "error",
          });
        }
        //console.log("rs statuses", statuses);
      },
      skip() {
        return this.searchId == "";
      },
    },
  },

  mounted() {
    this.reloader = setInterval(() => {
      this.reload();
    }, 2000);
    EventBus.$on("rs-clear", () => {
      clearInterval(this.reloader);
    });
  },
  beforeDestroy() {
    clearInterval(this.reloader);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/rates-search/RateSearchStatus.vue